import { Grid } from '@material-ui/core';
import React, { FC } from 'react';
import { AppGridProps } from '../types';

export const AppInputFiller: FC<AppGridProps> = (props) => {
  return <Grid item {...props} />;
};
